import { apiClient, type ApiOpts } from './client';

// ── Wire types (snake_case, matching Jackson SNAKE_CASE global config) ─

/**
 * Allowed preference keys as defined in UserPreferenceController.
 */
export type PreferenceKey =
  | 'workbench.layout'
  | 'workbench.chatPosition'
  | 'workbench.pinnedSurfaces'
  | 'ui.locale'
  | 'ui.theme';

export type UserPreferenceDto = {
  key: PreferenceKey;
  /** The value as raw JSON — a string, array, or object depending on the key. */
  value: unknown;
  updated_at: string;
};

export type UpdateUserPreferenceRequest = {
  value: unknown;
};

// ── API functions ───────────────────────────────────────────────────────

const BASE = '/api/v1/user/preferences';

export const userPreferencesApi = {
  list: (opts?: ApiOpts): Promise<UserPreferenceDto[]> =>
    apiClient.get<UserPreferenceDto[]>(BASE, opts),

  upsert: (
    key: PreferenceKey,
    value: unknown,
    opts?: ApiOpts,
  ): Promise<UserPreferenceDto> =>
    apiClient.put<UserPreferenceDto>(
      `${BASE}/${encodeURIComponent(key)}`,
      { value } satisfies UpdateUserPreferenceRequest,
      opts,
    ),
};
